// /skip's level half (spec 2026-10-04): the running GameScene registers a
// handler while a level is live, and a /skip delivery calls it. Kept apart
// from the scene so the inbox (which must not import Phaser) can reach the
// level being played without knowing what a scene is.

/** Ends the live level as a win; returns false when there is nothing to skip. */
export type LevelSkipHandler = () => boolean;

let handler: LevelSkipHandler | null = null;

/**
 * Register the live level's skip. Returns the unregister function, which only
 * clears the handler if it is still this one — a scene restarting into
 * itself registers the new run before the old one's SHUTDOWN fires.
 */
export function setLevelSkipHandler(h: LevelSkipHandler): () => void {
  handler = h;
  return () => {
    if (handler === h) handler = null;
  };
}

/** Win the level being played, if one is. True when a level was skipped. */
export function skipCurrentLevel(): boolean {
  if (!handler) return false;
  try {
    return handler();
  } catch (e) {
    console.warn('[skip] level skip failed', e);
    return false;
  }
}
